import { Menu, MenuItem } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { ReactComponent as PlusIcon } from "components/Icons/plus.svg";
import { FieldArray, FieldArrayRenderProps } from "formik";
import { useContextMenu } from "hooks/contextMenu";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { OLPaper } from "OLPaper";
import { selectAvaiableTranslations } from "reduxState/translations/translationsSlice";
import { FETierSetFormat } from "types/tierSets";
import { useStyles } from "../TierSetForm.styles";
import { Translation } from "./Translation";

interface Props {
  values: FETierSetFormat;
}

export const TierSetSettings = ({ values }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const contextMenu = useContextMenu();
  const availableLanguages = useAppSelector(selectAvaiableTranslations);

  return (
    <OLPaper className={classes.OLPaper}>
      <FieldArray
        name="translations"
        render={(translationsArray: FieldArrayRenderProps) => (
          <>
            {values?.translations?.map((item, index: number) => (
              <Translation
                key={index}
                isAnyTranslationAdded={values?.translations.length > 1}
                index={index}
                remove={translationsArray.remove}
                item={item}
              />
            ))}
            <OLButton
              className={classes.addTranslationBtn}
              color="secondary"
              data-test-id="add-translation"
              onClick={
                availableLanguages.filter(
                  ({ code }: { code: string }) =>
                    !values?.translations?.find(
                      (openLang: {
                        name?: string;
                        description?: string;
                        code?: string;
                      }) => openLang?.code === code,
                    ),
                ).length
                  ? contextMenu.handleMenuOpen
                  : undefined
              }
              startIcon={<PlusIcon />}
            >
              {message({ id: "translations" })}
            </OLButton>
            <Menu
              anchorEl={contextMenu.anchor}
              anchorOrigin={{
                horizontal: "right",
                vertical: "top",
              }}
              onClose={contextMenu.handleMenuClose}
              open={contextMenu.isMenuOpen}
              transformOrigin={{
                horizontal: "right",
                vertical: "top",
              }}
              data-test-id="languages"
            >
              {availableLanguages
                .filter(
                  ({ code }: { code: string }) =>
                    !values?.translations?.find(
                      (openLang: {
                        name?: string;
                        description?: string;
                        code?: string;
                      }) => openLang?.code === code,
                    ),
                )
                .map(({ code, name }: { code: string; name: string }) => (
                  <MenuItem
                    data-test-id="language"
                    key={code}
                    onClick={() => {
                      contextMenu.handleMenuClose();
                      translationsArray.push({
                        code: code,
                      });
                    }}
                  >
                    {name}
                  </MenuItem>
                ))}
            </Menu>
          </>
        )}
      />
    </OLPaper>
  );
};
